module.exports = __webpack_public_path__ + "img/6.a1b28bb6.png";